// 目前是存放各个表格的静态信息
export const tobedone = {
    table_init: {
        type: "待办事项",
        table_code: "t0",
        thead: [
            { label: "序号", code: "index" },
            { label: "标题", code: "unittype" },
            { label: "类型", code: "reqType" },
            { label: "创建时间", code: "personName" },
            { label: "当前状态", code: "bgNum" },
        ],
        body: []
    },
}
export const unitMenu_material = {
    table_list_init: [{
            type: "监理单位",
            name: "jl",
            table_code: "t1",
            thead: [{ label: "单位名称", code: "unitname" }, { label: "项目负责人", code: "projectPrincipal" }],
            body: [],
            fa_sort: "fa-sort-asc",
            show_table: true,
        },
        {
            type: "代建单位",
            name: "dj",
            table_code: "t2", //绑定表格
            thead: [{ label: "单位名称", code: "unitname" }, { label: "项目负责人", code: "projectPrincipal" }],
            body: [],
            fa_sort: "fa-sort-asc",
            show_table: true,
        },
        {
            type: "建设单位",
            name: "js",
            table_code: "t3", //多表格的时候 绑定表格
            thead: [{ label: "单位名称", code: "unitname" }, { label: "项目负责人", code: "projectPrincipal" }],
            body: [],
            fa_sort: "fa-sort-asc",
            show_table: true,
        },

    ]
}
const unitType = ["造价单位", , "", "", ""]
export const unitInfoMenu = {
    table_list_init: [{
            type: "建设单位",
            table_code: "t1", //多表格的时候 绑定表格
            thead: [
                { label: "建设单位", code: "unitName", sortable: false }, { label: "组织机构代码", code: "orgCode", sortable: false },
                { label: "法人代表", code: "legalPerson", sortable: false }, { label: "项目负责人", code: "projectPrincipal", sortable: false },
                { label: "联系电话", code: "projectPrincipal_phone", sortable: false }
            ]
        },
        {
            type: "代建单位",
            table_code: "t2", //绑定表格
            thead: [
                { label: "建设单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "项目负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "施工单位",
            table_code: "t3",
            thead: [{ label: "状态", code: "isFinish" }, { label: "施工单位", code: "unitname" },
                { label: "项目经理", code: "personName" }, { label: "资格等级", code: "personQualLevel" },
                { label: "身份证号", code: "personIdentity" }, { label: "联合子体", code: "unionUnit" },
                { label: "分包单位", code: "subUnit" }, { label: "同一施工标（与以下项目为同一份施工合同）", code: "superProName" },{ label: "与其他项目属分期开发建设或分多个施工标段，且同一地点、同一施工单位承建的项目", code: "fqProjectName" }
            ]
        },
        {
            type: "监理单位",
            table_code: "t4",
            thead: [{ label: "状态", code: "isFinish" }, { label: "监理单位", code: "unitname" },
                { label: "总监理工程师", code: "personName" }, { label: "资格等级", code: "personQualLevel" },
                { label: "身份证号", code: "personIdentity" }, { label: "联合子体", code: "unionUnit" }, { label: "同一监理标", code: "superProName" }
            ]
        },
        {
            type: "勘察单位",
            table_code: "t5",
            thead: [{ label: "勘察单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel" },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" },
                { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "设计单位",
            table_code: "t6",
            thead: [{ label: "设计单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel" },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" },
                { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "施工图审查单位",
            table_code: "t7",
            thead: [
                { label: "施工图审查单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel" }, { label: "资质证书号", code: "qualCertNo" },
            ]
        },
        {
            type: "造价单位",
            table_code: "t8", //绑定表格
            thead: [
                { label: "控制价（预算价）计价文件编制单位", code: "unitName" },
                { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel" }, { label: "资质证书号", code: "qualCertNo" },
                { label: "造价师", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        },
        {
            type: "招标代理单位",
            table_code: "t9", //绑定表格
            thead: [
                { label: "招标类型", code: "tender_class_num" }, { label: "招标方式", code: "tender_type_num" }, { label: '中标金额', code: 'tender_money'},
                { label: "中标单位", code: "zbUnitName" }, { label: "招标代理单位", code: "unitName" },
                { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel" }, { label: "资质证书号", code: "qualCertNo" },
                { label: "招标负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        },
        {
            type: "检测单位",
            table_code: "t10", //绑定表格
            thead: [
                { label: "检测单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel" },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        }
    ],
    table_list_init_reform: [{
        type: "建设单位",
        table_code: "t1", //多表格的时候 绑定表格
        thead: [
            { label: "建设单位", code: "unitName", sortable: false }, { label: "组织机构代码", code: "orgCode", sortable: false },
            { label: "法人代表", code: "legalPerson", sortable: false }, { label: "项目负责人", code: "projectPrincipal", sortable: false },
            { label: "联系电话", code: "projectPrincipal_phone", sortable: false }
        ]
    },
        {
            type: "代建、工程总承包（EPC）、PPP等单位",
            table_code: "t2", //绑定表格
            thead: [
                { label: "建设单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "项目负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "施工单位",
            table_code: "t3",
            thead: [{ label: "状态", code: "isFinish" }, { label: "施工单位", code: "unitname" },
                { label: "项目经理", code: "personName" }, { label: "资格等级", code: "personQualLevel" },
                { label: "身份证号", code: "personIdentity" }, { label: "联合子体", code: "unionUnit" },
                { label: "分包单位", code: "subUnit" }, { label: "同一施工标（与以下项目为同一份施工合同）", code: "superProName" },
            ]
        },
        {
            type: "监理单位",
            table_code: "t4",
            thead: [{ label: "状态", code: "isFinish" }, { label: "监理单位", code: "unitname" },
                { label: "总监理工程师", code: "personName" }, { label: "资格等级", code: "personQualLevel" },
                { label: "身份证号", code: "personIdentity" }, { label: "联合子体", code: "unionUnit" }, { label: "同一监理标", code: "superProName" }
            ]
        },
        {
            type: "勘察单位",
            table_code: "t5",
            thead: [{ label: "勘察单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel",dictionary: "domus_investQualLevel" },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" },
                { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "设计单位",
            table_code: "t6",
            thead: [{ label: "设计单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel",dictionary: "domus_investQualLevel" },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" },
                { label: "联系电话", code: "projectPrincipal_phone" }
            ]
        },
        {
            type: "施工图审查单位",
            table_code: "t7",
            thead: [
                { label: "施工图审查单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel" }, { label: "资质证书号", code: "qualCertNo" },
            ]
        },
        {
            type: "控制价（预算价）计价文件编制单位",
            table_code: "t8", //绑定表格
            thead: [
                { label: "控制价（预算价）计价文件编制单位", code: "unitName" },
                { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel"}, { label: "资质证书号", code: "qualCertNo" },
                { label: "造价师", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        },
        {
            type: "招标代理单位",
            table_code: "t9", //绑定表格
            thead: [
                { label: "招标类型", code: "tender_class_num" }, { label: "招标方式", code: "tender_type_num" },{ label: "中标金额", code: "tender_money" },
                { label: "中标单位", code: "zbUnitName" }, { label: "招标代理单位", code: "unitName" },
                { label: "组织机构代码", code: "orgCode" }, { label: "法人代表", code: "legalPerson" },
                { label: "资质等级", code: "qualLevel" }, { label: "资质证书号", code: "qualCertNo" },
                { label: "招标负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        },
        {
            type: "检测单位",
            table_code: "t10", //绑定表格
            thead: [
                { label: "检测单位", code: "unitName" }, { label: "组织机构代码", code: "orgCode" },
                { label: "法人代表", code: "legalPerson" }, { label: "资质等级", code: "qualLevel", },
                { label: "资质证书号", code: "qualCertNo" }, { label: "项目负责人", code: "projectPrincipal" }, { label: "联系电话", code: "projectPrincipal_phone" },
            ]
        }
    ],

    table_1: [
        { name: "厦门路桥建设集团有限公司", oth1: "", code: "155006263", legalMan: "", oth2: "", chargeMan: "肖张辉", tel: "15980966422" },
        { name: "疯狂打call有限公司", oth1: "", code: "6666666", legalMan: "", oth2: "", chargeMan: "小刘", tel: "15980966422", oth1: "", oth2: "" }
    ],
    table_3: [{
        res: "已释放",
        name: "福建省恒大建设工程有限公司",
        oth1: "",
        chargeMan: "陈连寿",
        oth2: "",
        level: "二级注册建造师",
        entityId: "352624195606010018",
        null1: "",
        null2: "",
        null3: "",
        null4: ""
    }, ]
}
export const PojectItemMenu = {
    table_init: {
        type: "单位工程",
        table_code: "t0", //多表格的时候 绑定表格
        thead: [
            { label: "单位工程名称", code: "singleProName", link: true },
            { label: "单位工程类别", code: "singleProType", width: "240" },
            // { label: "主类别", code: "singleProMaintype" },
            // { label: "类别", code: "singleProType" },
            // { label: "子类", code: "singleProSubtype" },
            { label: "结构质式", code: "structQualType" },
            { label: "建筑高度(m)", code: "archHeight" },
            { label: "±0.00以下结构层数", code: "basementFloorNum" },
            { label: "市政长度(M)", code: "muniLength" },
            { label: "状态", code: "status" },
        ],
        body: [] //存放axios返回的数据
    },
    dialog_data_init: {
        "singleProName": "",
        "itemnum": "",
        "hassubitem": "",
        "singleProMaintype": "",
        "singleProType": "",
        "singleProSubtype": "",
        "muniLength": "",
        "structMaxSpan": "",
        "hasConLayer": "",
        "foundSupWay": "",
        "foundDepth": "",
        "foundSupWay": "",
        "infraLevel": "",
        "buildWall": "",
        "refractLevel": "",
        "structQualType": "",
        "rebelQuakeLevel": "",
    }
}

// 单位工程名称','单位工程类别','上部(地下室)施工单位','上部(地下室)监理单位','结构质式','状态
export const SBItem = {
    table_init: {
        type: "上部（地下室）工程信息",
        table_code: "t0",
        thead: [
            { label: "单位工程名称", code: "singleProName", link: true },
            { label: "单位工程类别", code: "singleProMaintype" },
            { label: "上部(地下室)施工单位", code: "buildUnion" },
            { label: "上部(地下室)监理单位", code: "superUnion" },
            { label: "结构质式", code: "structQualType" },
            { label: "状态", code: "status" },
        ],
        body: []
    }
}

export const ZYItemMenu = {
    table_init: {
        type: "专业发包工程",
        table_code: "t0",
        thead: [
            { label: "单位工程名称", code: "singleProName", link: true },
            { label: "单位工程类别", code: "singleProMaintype" },
            { label: "专业发包施工单位", code: "buildUnion" },
            { label: "专业发包监理单位", code: "superUnion" },
            { label: "专业发包类型", code: "specType" },
            { label: "状态", code: "status" },
        ],
        body: []
    }
}
export const ZJItemMenu = {
    table_init: {
        type: "桩基（基础）工程信息",
        table_code: "t0",
        thead: [
            { label: "单位工程名称", code: "singleProName", link: true },
            { label: "单位工程类别", code: "singleProMaintype" },
            { label: "桩基（基础）施工单位", code: "buildUnion" },
            { label: "桩基（基础）监理单位", code: "superUnion" },
            { label: "结构质式", code: "structQualType" },
            { label: "状态", code: "status" },
        ],
        body: []
    }
}
export const BuildPersonMenu = {
    table_init: {
        type: "施工人员备案",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "unitName", link: true },
            { label: "备案时间", code: "contractDate", dictionary: "date" },
            { label: "备案情况", code: "status" },
            { label: "备案项目", code: "unitServeProName" },
        ],
        body: []
    },
    table_init_reform: {
        type: "施工人员备案",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "unitName", link: true },
            { label: "当前状态", code: "status" },
            { label: "同一施工标的项目", code: "unitServeProName" },
        ],
        body: []
    },
    dialog_data_record_init: {
        "proName": "",
        "unionName": "",
        "singleProNames": "",
        "singleProNames2": "",
        "section": "",
        "contractNumber": "",
        "planBegDate": "",
        "planEndDate": "",
        "contractDate": ""
    },
    dialog_data_people_init: [{
        "personName": "",
        "personIdentity": "",
        "station": "",
        "personTitle": "",
        "personProf": "",
        "personCert": "",
        "serviceStage": "",
        "obtainedYear": "",
        "status": ""
    }],
    fakeData: [
        { "serveId": "61b80a69-9180-11e4-9011-fb22a2287298", "proId": "31206", "decItemId": "806bccaa-917f-11e4-9011-fb22a2287298", "reqType": "项目申报", "infoid": "3972", "unitName": "福建闽能咨询有限公司", "unittype": "监理单位", "contractDate": "2014-12-16", "unionName": null, "status": "中止评价释放", "unitServeProName": "" },
        { "serveId": "23333333-9180-11e4-9011-fb22a2287298", "proId": "31206", "decItemId": "806bccaa-917f-11e4-9011-fb22a2287298", "reqType": "项目申报", "infoid": "3972", "unitName": "评论喊6有限公司", "unittype": "监理单位", "contractDate": "2014-12-16", "unionName": null, "status": "中止评价释放", "unitServeProName": "" }
    ]
}
export const SuperPersonMenu = {
    table_init: {
        type: "监理人员备案",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "unitName", link: true },
            { label: "备案时间", code: "contractDate" },
            { label: "备案情况", code: "status" },
            { label: "备案项目", code: "unitServeProName" },
        ],
        body: []
    },
    table_init_reform: {
        type: "监理人员备案",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "unitName", link: true },
            { label: "当前状态", code: "status" },
            { label: "同一监理标的项目", code: "unitServeProName" },
        ],
        body: []
    },
    dialog_data_record_init: {
        "proName": "",
        "unionName": "",
        "singleProNames": "",
        "singleProNames2": "",
        "section": "",
        "contractNumber": "",
        "planBegDate": "",
        "planEndDate": "",
        "contractDate": ""
    },
    dialog_data_people_init: [{
        "personName": "",
        "personIdentity": "",
        "station": "",
        "personTitle": "",
        "personProf": "",
        "personCert": "",
        "serviceStage": "",
        "obtainedYear": "",
        "status": ""
    }],
    fakeData: [
        { "serveId": "61b76e4d-9180-11e4-9011-fb22a2287298", "proId": "29643", "decItemId": "808a5177-917f-11e4-9011-fb22a2287298", "reqType": "项目申报", "infoid": "3998", "unitName": "福州诺成工程项目管理有限公司", "unittype": "监理单位", "contractDate": "2014-12-16", "unionName": null, "status": "变更产生的临时数据", "unitServeProName": "" },
        { "serveId": "23333333-9180-11e4-9011-fb22a2287298", "proId": "29643", "decItemId": "808a5177-917f-11e4-9011-fb22a2287298", "reqType": "项目申报", "infoid": "3998", "unitName": "困到炸裂有限公司", "unittype": "监理单位", "contractDate": "2014-12-16", "unionName": null, "status": "变更产生的临时数据", "unitServeProName": "" }
    ]
}
export const numberTest = {
    table_init: {
        type: "数据监测",
        table_code: "t0",
        thead: [
            { label: "工程项目编码", code: "pronum", link: true },
            { label: "工程项目名称", code: "proName" },
            { label: "检测机构代码", code: "jcjgid" },
            { label: "检测机构名称", code: "jcjgname" },
            { label: "报告编号", code: "reportid" },
            { label: "合同编号", code: "compactid" },
            { label: "样品编号", code: "sampleid" },
            { label: "实验编号", code: "experimentid" },
            { label: "状态", code: "status" },
            { label: "数据同步时间", code: "syncTime", dictionary: "date" },
        ],
        body: []
    }
}
export const constrInfo = {
    table_init: {
        type: "施工许可信息查看",
        table_code: "t0",
        thead: [
            { label: "施工许可证号", code: "constr_num" },
            { label: "建设单位", code: "con_unit" },
            { label: "工程项目名称", code: "pro_name" },
            { label: "合同开工时间", code: "plan_beg_date" },
            { label: "合同完工时间", code: "plan_end_date" },
            { label: "质量监督机构", code: "qual_super_org" },
            { label: "提交时间", code: "sub_date" },
            { label: "审核通过时间", code: "confirm_date" },
            { label: "状态", code: "status", dictionary: "status" },
        ],
        body: []
    },
}
export const PersonChangeMenu = {
    table_init: {
        type: "人员变更历史",
        table_code: "t0",
        thead: [
            { label: "单位名称", code: "unitname", link: true },
            { label: "单位类型", code: "unittype" },
            { label: "所属申报项", code: "reqType" },
            { label: "负责人", code: "personName" },
            { label: "变更人员数量", code: "bgNum" },
            { label: "新增人员数量", code: "xzNum" },
        ],
        body: []
    },
}
export const ProjectMaterial = {
    table_init: {
        type: "工程材料报审",
        table_code: "t0",
        thead: [
            { label: "编号", code: "materialsNum", sortable: true },
            { label: "项目名称", code: "proName", sortable: true },
            { label: "材料验收类型", code: "materialsType", sortable: true },
            { label: "承包单位", code: "cbUnitName", sortable: true },
            { label: "项目经理", code: "pmName", sortable: true },
            { label: "进场时间", code: "admissionDate", sortable: true },
            { label: "审查单位类型", code: "unittype", sortable: true },
            { label: "审查单位", code: "scUnitName", sortable: true },
            { label: "审查人", code: "scPersonName", sortable: true },
            { label: "当前状态", code: "status", sortable: true },
        ],
        body: []
    }
}
export const materialCheckQuery = {
    table_init: {
        type: "主要材料报审记录搜索",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proName", link: true, sortable: true },
            { label: "报审表类型", code: "reportFormType", sortable: true, dictionary: "reportFormType" },
            { label: "建设单位", code: "jsUnitName", sortable: true },
            { label: "施工单位", code: "sgUnitName", sortable: true },
            { label: "监理单位", code: "jlUnitName", sortable: true },
            { label: "提交时间", code: "submitTime", sortable: true, dictionary: "date" },
            { label: "报审时间", code: "reviewDate", sortable: true, dictionary: "date" },
        ],
        body: []
    }
}
export const materialOriginPublic = {
    table_init: {
        type: "主要材料溯源公示平台",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "pro_name", link: true, sortable: true },
            { label: "报审表类型", code: "reportFormType", sortable: true, dictionary: "reportFormType" },
            { label: "建设单位", code: "jsUnitName", sortable: true },
            { label: "施工单位", code: "sgUnitName", sortable: true },
            { label: "监理单位", code: "jlUnitName", sortable: true },
            { label: "报监时间", code: "aqConfirmDate", sortable: true, dictionary: "date" },
        ],
        body: []
    }
}
export const curtainWall = {
    table_init_not_list: {
        type: "幕墙(除了list)",
        table_code: "t0",
        thead: [
            { label: "序号", code: "index", sortable: true, width: "300" },
            { label: "项目名称", code: "proName", sortable: true, width: "200" },
            { label: "工程项目代码", code: "pronum", sortable: true },
            { label: "项目类别", code: "proType", sortable: true },
            { label: "建设单位", code: "unitName", sortable: true },
            { label: "项目状态", code: "proStatus", sortable: true },
            { label: "变更类型", code: "updateType", sortable: true },
            { label: "流程开始时间", code: "wfStartTime", sortable: true },
            { label: "流程结束时间", code: "wfEndTime", sortable: true },
            { label: "变更状态", code: "thisActivityInfo", sortable: true },
            { label: "当前环节", code: "wfStatus", sortable: true },
        ],
        body: []
    },
    table_init_list: {
        type: "幕墙(list)",
        table_code: "t0",
        thead: [
            // { label: "序号", code: "index", sortable: true },
            { label: "工程项目名称", code: "proName", sortable: true, width: "200" },
            { label: "工程项目代码", code: "pronum", sortable: true },
            { label: "建设单位", code: "conUnit", sortable: true },
            { label: "建设单位机构代码", code: "conOrgCode", sortable: true },
            { label: "工程项目类别", code: "proType", sortable: true, dictionary: "proType" },
            { label: "单位工程个数", code: "singleProNum", sortable: true },
            { label: "项目总造价（万元）", code: "proCost", sortable: true },
            { label: "项目总面积（M²）", code: "proArea", sortable: true },
            { label: "项目市政总长度(M)", code: "muniLength", sortable: true },
            { label: "质量监督机构", code: "qualSuperOrg", sortable: true },
            { label: "安全监督机构", code: "secSuperOrg", sortable: true },
            { label: "项目状态", code: "status", sortable: true, dictionary: "dbstatus" },
        ],
        body: []
    },
}

export const blacklist = {
    table_init: {
        type: "黑名单人员考勤申报",
        table_code: "t0",
        thead: [
            { label: "工程项目名称", code: "proName", sortable: true, width: "300" },
            { label: "工程项目代码", code: "pronum", sortable: true },
            { label: "申报类别", code: "", sortable: true },
            { label: "总承包单位", code: "", sortable: true },
            { label: "建设单位", code: "conUnit", sortable: true },
            { label: "建设单位机构代码", code: "conOrgCode", sortable: true },
            { label: "工程项目类别", code: "proType", sortable: true },
            { label: "单位工程个数", code: "singleProNum", sortable: true },
            { label: "项目总造价（万元）", code: "proCost", sortable: true },
            { label: "项目总面积（M²）", code: "proArea", sortable: true },
            { label: "项目市政总长度(M)", code: "muniLength", sortable: true },
            { label: "质量监督机构", code: "qualSuperOrg", sortable: true },
            { label: "安全监督机构", code: "secSuperOrg", sortable: true },
            { label: "项目状态", code: "dbstatus", sortable: true },
            { label: "质量审批状态", code: "", sortable: true },
            { label: "安全审批状态", code: "", sortable: true },
            { label: "提交时间", code: "", sortable: true },
            { label: "是否列入双随机", code: "", sortable: true },
        ],
        body: []
    }
}
export const applications = {
    table_init: {
        type: "项目报建及日常管理过程查询",
        table_code: "t0",
        thead: [
            { label: "工程项目名称", code: "proName", sortable: true, width: "300" },
            { label: "工程项目代码", code: "pronum", sortable: true },
            { label: "申报类别", code: "", sortable: true },
            { label: "总承包单位", code: "", sortable: true },
            { label: "建设单位", code: "conUnit", sortable: true },
            { label: "建设单位机构代码", code: "conOrgCode", sortable: true },
            { label: "工程项目类别", code: "proType", sortable: true },
            { label: "单位工程个数", code: "singleProNum", sortable: true },
            { label: "项目总造价（万元）", code: "proCost", sortable: true },
            { label: "项目总面积（M²）", code: "proArea", sortable: true },
            { label: "项目市政总长度(M)", code: "muniLength", sortable: true },
            { label: "质量监督机构", code: "qualSuperOrg", sortable: true },
            { label: "安全监督机构", code: "secSuperOrg", sortable: true },
            { label: "项目状态", code: "dbstatus", sortable: true },
            { label: "质量审批状态", code: "", sortable: true },
            { label: "安全审批状态", code: "", sortable: true },
            { label: "提交时间", code: "", sortable: true },
            { label: "是否列入双随机", code: "", sortable: true },
        ],
        body: []
    }
}
export const dangerPlan = {
        table_init: {
            type: "危险源计划查看",
            table_code: "t0",
            thead: [
                { label: "工程项目名称", code: "proName", sortable: true, link: true, width: "300" },
                { label: "工程项目代码", code: "pronum", sortable: true },
                { label: "建设单位", code: "conUnit", sortable: true },
                { label: "建设单位机构代码", code: "conOrgCode", sortable: true },
                { label: "工程项目类别", code: "proType", sortable: true,dictionary: "proType" },
                { label: "单位工程个数", code: "singleProNum", sortable: true },
                { label: "项目总造价（万元）", code: "proCost", sortable: true },
                { label: "项目总面积（M²）", code: "proArea", sortable: true },
                { label: "项目市政总长度(M)", code: "muniLength", sortable: true },
                { label: "监督机构", code: "qualSuperOrg", sortable: true },
                { label: "项目状态", code: "status", sortable: true, dictionary: "dbstatus" },
            ],
            body: []
        }
    }
    //dictionary是要对应的对象列表名 || date表示是时间转换
export const dangerQR = {
    table_init: {
        type: "危险源搜索与解除",
        table_code: "t0",
        table_formatter: { dangerType: "", dangerLevel: "", realBegDate: "" },
        thead: [
            { label: "项目名称", code: "proName", sortable: true, width: 200, link: true },
            { label: "危险源类型", code: "dangerType", sortable: true, dictionary: "dangerType" },
            { label: "危险性", code: "dangerLevel", sortable: true, dictionary: "dangerLevel" },
            { label: "单位工程", code: "singleProName", sortable: true },
            { label: "危险源部位", code: "dangerSite", sortable: true },
            { label: "项目负责人", code: "proResPerson", sortable: true },
            { label: "实际开工时间", code: "realBegDate", sortable: true, dictionary: "date" },
            { label: "状态", code: "status", sortable: true },
        ],
        body: []
    },
    dialog_detail: [{}],
    dialog_release: [{}],
}

//zcy
export const dangerQuery = {
    table_init: {
        type: "危险源搜索",
        table_code: "t0",
        thead: [
            { label: "工程项目名称", code: "proName", sortable: true, link: true, width: "300" },
            { label: "建设单位", code: "conUnit", sortable: true },
            { label: "监理单位", code: "supervisor", sortable: true },
            { label: "施工单位", code: "execution", sortable: true },
            { label: "项目经理", code: "personName", sortable: true },
            { label: "危险源个数", code: "dangerNum", sortable: true },
        ],
        body: []
    }
}
export const dangerDialog = {
    table_init: {
        type: "危险源查看列表",
        table_code: "t0",
        thead: [
            { label: "危险源类型", code: "dangerType", sortable: true, width: "300" },
            { label: "危险性", code: "dangerLevel", sortable: true },
            { label: "单位工程", code: "singleProName", sortable: true },
            { label: "危险源部位", code: "dangerSite", sortable: true },
            { label: "项目负责人", code: "proResPerson", sortable: true },
            { label: "实际开工时间", code: "realBegDate", sortable: true },
            { label: "状态", code: "status", sortable: true },
            // { label: "操作", code: "cz", sortable: true },
        ],
        body: []
    }
}

//liu
export const Regist = {
        table_init_list: { //=危险源计划查看
            type: "危险源登记",
            table_code: "t0",
            thead: [
                { label: "工程项目名称", code: "proName", sortable: true, width: "300" },
                { label: "工程项目代码", code: "pronum", sortable: true },
                { label: "建设单位", code: "conUnit", sortable: true },
                { label: "建设单位机构代码", code: "conOrgCode", sortable: true },
                { label: "工程项目类别", code: "proType", sortable: true, dictionary: "proType" },
                { label: "单位工程个数", code: "singleProNum", sortable: true },
                { label: "项目总造价（万元）", code: "proCost", sortable: true },
                { label: "项目总面积（M²）", code: "proArea", sortable: true },
                { label: "项目市政总长度(M)", code: "muniLength", sortable: true },
                { label: "监督机构", code: "qualSuperOrg", sortable: true },
                { label: "项目状态", code: "status", sortable: true, dictionary: "dbstatus" },
            ],
            body: []
        },
        table_init_wait: {
            type: "危险源登记_在办",
            table_code: "t0",
            thead: [
                { label: "工程项目名称", code: "proName", sortable: true, link: true, width: "300" },
                { label: "危险源类型", code: "dangerType", sortable: true, dictionary: "dangerType" },
                { label: "危险性", code: "dangerLevel", sortable: true, dictionary: "dangerLevel" },
                { label: "单位工程", code: "singleProName", sortable: true },
                { label: "危险源部位", code: "dangerSite", sortable: true },
                { label: "项目负责人", code: "proResPerson", sortable: true },
                { label: "实际开工时间", code: "realBegDate", sortable: true, dictionary: "date" },
                { label: "状态", code: "dangerStatus", sortable: true, dictionary: "status" },
                /*{ label: "退回原因", code: "backReason", sortable: true },*/
            ],
            body: []
        },
        table_init_already: {
            type: "危险源登记_已办",
            table_code: "t0",
            thead: [
                { label: "项目名称", code: "proName", sortable: true, link: true, width: "300" },
                /*{ label: "变更状态", code: "updateType", sortable: true },*/
                { label: "危险源类型", code: "dangerType", sortable: true, dictionary: "dangerType" },
                { label: "危险性", code: "dangerLevel", sortable: true, dictionary: "dangerLevel" },
                { label: "单位工程", code: "singleProName", sortable: true },
                { label: "危险源部位", code: "dangerSite", sortable: true },
                { label: "项目负责人", code: "proResPerson", sortable: true },
                { label: "实际开工时间", code: "realBegDate", sortable: true, dictionary: "date" },
                /*{ label: "流程开始时间", code: "wfStartTime", sortable: true },
                { label: "流程结束时间", code: "wfEndTime", sortable: true },*/
                { label: "状态", code: "dangerStatus", sortable: true, dictionary: "status" },
            ],
            body: []
        },
        table_init_all: {
            type: "危险源登记_全部",
            table_code: "t0",
            thead: [
                { label: "项目名称", code: "proName", sortable: true, link: true, width: "300" },
                /*{ label: "变更状态", code: "updateType", sortable: true },*/
                { label: "危险源类型", code: "dangerType", sortable: true, dictionary: "dangerType" },
                { label: "危险性", code: "dangerLevel", sortable: true, dictionary: "dangerLevel" },
                { label: "单位工程", code: "singleProName", sortable: true },
                { label: "危险源部位", code: "dangerSite", sortable: true },
                { label: "项目负责人", code: "proResPerson", sortable: true },
                { label: "实际开工时间", code: "realBegDate", sortable: true, dictionary: "date" },
                /*{ label: "流程开始时间", code: "wfStartTime", sortable: true },
                { label: "流程结束时间", code: "wfEndTime", sortable: true },*/
                { label: "状态", code: "dangerStatus", sortable: true, dictionary: "status" },
                /*{ label: "退回原因", code: "backReason", sortable: true },*/
            ],
            body: []
        },
        itemPro_table_init: {
            type: "基坑工程危险源信息录入_单位工程名称",
            table_code: "t0",
            thead: [
                // { label: "序号", code: "index" },
                { label: "单位工程名称", code: "singleProName" },
                { label: "单位工程类别", code: "singleProType" },
                { label: "类别", code: "itemType" },
            ],
            body: []
        }
    }
    // dictionary_{"dbstatus": Dictionaries.dbstatus},
    //link会直接调用queryItem事件，调用vue要写method
export const seasonCheckRigist = {
    table_init: {
        type: "项目季考评（登记）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: false, sortable: true, width: "400" },
            { label: "监督审核通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date", width: "200" },
            { label: "年份", code: "curyear", sortable: true },
            { label: "季度", code: "curquarter", sortable: true, dictionary: "curquarter" },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "提交日期", code: "enddate", sortable: true, dictionary: "date" },
            { label: "是否超时限", code: "isover", sortable: true, dictionary: "isover" },
            { label: "状态", code: "opstatemc", sortable: true },
        ],
        body: []
    },
    detail_init: {
        proname: "",
        conunitmc: "",
        checkdate: "",
        xmjlmc: "",
        zgidea: "",
        evalgrade: "",
        evalresult: "优良",
    }
}
export const doneCheckSign = {
    table_init: {
        type: "项目竣工考评（签章）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "400" },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "建设单位", code: "jsdwmc", sortable: true },
            { label: "监理单位", code: "jldwmc", sortable: true },
            { label: "自评分数", code: "evalgaint", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true,dictionary: "opstatemc"  },
        ],
        body: []
    },
}

export const monthCheckQuery = {
    table_init: {
        type: "项目月考评（搜索）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200" },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "监督审核通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "年份", code: "curyear", sortable: true },
            { label: "月份", code: "curmonth", sortable: true },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "状态", code: "opStatemc", sortable: true },
            { label: "项目经理是否逾期", code: "isover", sortable: true, dictionary: "isover", width: "100" },
            { label: "项目经理提交日期", code: "sgdwsigndate", sortable: true, dictionary: "date", width: "100" },
            { label: "总监是否逾期", code: "isSEOvertime", sortable: true, dictionary: "isSEOvertime" },
            { label: "监理工程师盖章日期", code: "jldwsigndate", sortable: true, dictionary: "date" },
            { label: "建设单位项目负责人盖章日期", code: "jsdwsigndate", sortable: true, dictionary: "date" },
            { label: "提交日期", code: "enddate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
    table_init_sign: {
        type: "项目月考评（盖章）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200" },
            { label: "年份", code: "curyear", sortable: true },
            { label: "月份", code: "curmonth", sortable: true },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "建设单位", code: "jsdwmc", sortable: true },
            { label: "监理单位", code: "jldwmc", sortable: true },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
        ],
        body: []
    },
    detail_init: {
        proname: "",
        checkdate: "",
        sgdwxmfzr: "",
        sgdwxmfzrzsh: "",
        evalidea: "",
        jsdwmc: "",
        jsdwxmfzr: "",
        jldwmc: "",
        jldwgcsmc: "",
        evalgrade: "",
        evalresult: "",
    }
}
export const doneCheckQuery = {
    table_init: {
        type: "项目竣工考评（搜索）",
        table_code: "t0",
        thead: [
            // { label: "选择", code: "radio"},
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200" },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "施工企业名称", code: "conunitmc", sortable: true, width: "100" },

            { label: "监督审核通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date", width: "100" },

            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "考评结果", code: "finalresult", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true, dictionary: "opstatemc" },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "项目经理", code: "sgdwxmfzrmc", sortable: true },
            { label: "项目经理提交日期", code: "opdate", sortable: true, dictionary: "date", width: "100" },
            { label: "监理单位", code: "jldwmc", sortable: true, width: "150" },
            { label: "总监盖章日期", code: "jldwsigndate", sortable: true, dictionary: "date", width: "100" },
            { label: "建设单位", code: "jsdwmc", sortable: true, width: "150" },
            { label: "建设单位项目负责人盖章日期", code: "jsdwsigndate", sortable: true, dictionary: "date", width: "100" },
            { label: "施工单位盖章日期", code: "sgdwsigndate", sortable: true, dictionary: "date", width: "100" },
            { label: "提交审核日期", code: "submitdate", sortable: true, dictionary: "date", width: "100" },
            { label: "审核日期", code: "finaltrialdate", sortable: true, dictionary: "date", width: "100" },
        ],
        body: []
    },
}

//竣工考评 里面还有相关材料，8~10个表格 start
export const MaterialsMonthSeason = {
    table_init: {
        type: "项目自评机构开展自评工作情况 / 项目季度监督检查工作情况",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200", link: true },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "年份", code: "curyear", sortable: true, width: "100" },
            { label: "月份", code: "curmonth", sortable: true, width: "100" },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "监督审核时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "提交时间", code: "enddate", sortable: true, dictionary: "date" },
            { label: "是否竣工", code: "isend", sortable: true, dictionary: "isend" },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "状态", code: "opStatemc", sortable: true },
        ],
        body: []
    },
}
export const MaterialsSeasonSeason = {
    table_init: {
        type: "项目季度监督检查工作情况",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200", link: true },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "年份", code: "curyear", sortable: true, width: "100" },
            { label: "季度", code: "curquarter", sortable: true, width: "100" },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "监督审核时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "提交时间", code: "enddate", sortable: true, dictionary: "date" },
            { label: "是否竣工", code: "isend", sortable: true, dictionary: "isend" },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "状态", code: "opStatemc", sortable: true },
        ],
        body: []
    },
}

export const badCreditInfo = {
    table_init: {
        type: "发生生产安全责任事故情况",
        table_code: "t0",
        thead: [
            { label: "评价标题", code: "situation", sortable: true, width: "300", },
            { label: "不良行为描述", code: "content", sortable: true , width: "300",},
            { label: "不良行为发生日期", code: "happenDate", sortable: true, dictionary: "date"},
            { label: "事故原因", code: "accidentReason", sortable: true,},
            { label: "事故类型", code: "accidentType", sortable: true },
            { label: "处罚部门", code: "departName", sortable: true, },
            { label: "处罚决定文号", code: "fileNum", sortable: true },
            { label: "处罚日期", code: "punishDate", sortable: true, dictionary: "date", width: "120" },
        ],
        body: []
    },
}

export const spotCheckNoticeSearch = {
    table_init: {
        type: "责任停工搜索",
        table_code: "t0",
        thead: [
            { label: "责改编码", code: "notice_serid", link: true, sortable: true, width: "200" },
            { label: "检查时间", code: "checkTime", sortable: true, dictionary: "date" },
            { label: "责改类型", code: "notice_type", sortable: true },
            { label: "处理意见", code: "notice_handle", sortable: true },
        ],
        body: []
    },
}

export const actScoreNotices = {
    table_init: {
        type: "施工安全考核记分情况",
        table_code: "t0",
        thead: [
            { label: "编号", code: "scorenoticeSuid", link: true, sortable: true, width: "200" },
            { label: "工程项目名称", code: "proName", sortable: true },
            { label: "记分主体", code: "name", sortable: true },
            { label: "所记分值", code: "score", sortable: true },
            { label: "所记安全分值", code: "safetyScore", sortable: true },
            { label: "签发时间", code: "activeDate", sortable: true, dictionary: "date" },
            { label: "生效日期", code: "onlineDatetime", sortable: true, dictionary: "date" },
        ],
        body: []
    },
}

export const doneResultPublicity = {
    table_init: {
        type: "竣工考评结果公示书",
        table_code: "t0",
        thead: [
            { label: "公示书编号", code: "publicitybh", sortable: true, link: true },
            { label: "项目名称", code: "proname", sortable: true },
            { label: "所在地", code: "totalname", sortable: true },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "考评结果", code: "finaltrialresult", sortable: true },
            { label: "公示期限", code: "publicitystadate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
}
export const doneResultInform = {
    table_init: {
        type: "竣工考评结果告知书",
        table_code: "t0",
        thead: [
            { label: "告知书编号", code: "informbh", sortable: true, link: true },
            { label: "项目名称", code: "proname", sortable: true },
            { label: "所在地", code: "totalname", sortable: true },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "考评结果", code: "finalresult", sortable: true },
        ],
        body: []
    },
};
export const objectionCheckQuery = {
    table_init: {
        type: "项目考评异议核实（搜索）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "200" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "考评结果", code: "evalresult", sortable: true },
            { label: "异议结果", code: "finaltrialresult", sortable: true },
            { label: "申请人", code: "sqmanmc", sortable: true },
            { label: "联系电话", code: "sqmantel", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "登记(受理)时间", code: "opdate", sortable: true, dictionary: "date" },
            { label: "审核通过实时间", code: "finaltrialdate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
export const revokeCheckResQuery = {
    table_init: {
        type: "撤销项目考评结果（搜索）",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "300" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "申请日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstate", sortable: true, dictionary: "opstate" },
            { label: "公示起始日期", code: "publicitystadate", sortable: true, dictionary: "date" },
            { label: "公示截止日期", code: "publicitydate", sortable: true, dictionary: "date" },
            { label: "公示书编号", code: "publicitybh", sortable: true },
            { label: "决定书编号", code: "informbh", sortable: true },
        ],
        body: []
    },
};

export const revokeCheckResPublicity = {
    table_init: {
        type: "撤销项目考评结果公式书",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "300" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "公示书编号", code: "publicitybh", sortable: true },
            { label: "公示起始日期", code: "publicitystadate", sortable: true, dictionary: "date" },
            { label: "公示截止日期", code: "publicitydate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstate", sortable: true, dictionary: "opstate" },
        ],
        body: []
    },
};

//优秀项目
export const goodDecl_ready = {
    table_init: {
        type: "省级优良项目申报(登记) - 未申报/申报中",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "300" },
            { label: "建设单位", code: "devunitmc", sortable: true },
            { label: "企业名称", code: "conunitmc", sortable: true },
            { label: "工程类别", code: "protype", sortable: true },
            { label: "建筑面积", code: "proarea", sortable: true },
            { label: "工程造价", code: "procost", sortable: true },
            { label: "施工许可证编号", code: "sgxkzhm", sortable: true },
            { label: "结构类型", code: "structtype", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "意见", code: "applyidea", sortable: true },
        ],
        body: []
    },
};
export const goodDecl_end = {
    table_init: {
        type: "省级优良项目申报(登记) - 已完成",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "200" },
            { label: "建设单位", code: "devunitmc", sortable: true },
            { label: "监理单位", code: "superunitmc", sortable: true },
            { label: "企业名称", code: "conunitmc", sortable: true },
            { label: "项目经理", code: "conunitmcxmfzrmc", sortable: true },
            { label: "所在设区市", code: "totalname", sortable: true },
            { label: "所在县(市、区)", code: "belong", sortable: true },
            { label: "工程类别", code: "protype", sortable: true },
            { label: "建筑面积", code: "proarea", sortable: true },
            { label: "工程造价", code: "procost", sortable: true },
            { label: "施工许可证编号", code: "sgxkzhm", sortable: true, width: "300" },
            { label: "结构类型", code: "structtype", sortable: true },
            { label: "提交日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "意见", code: "finaltrialidea", sortable: true },
        ],
        body: []
    },
};
export const goodDecl_fail = {
    table_init: {
        type: "省级优良项目申报(登记) - 未通过",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true, width: "200" },
            { label: "企业名称", code: "conunitmc", sortable: true },
            { label: "工程类别", code: "protype", sortable: true },
            { label: "建筑面积", code: "proarea", sortable: true },
            { label: "工程造价", code: "procost", sortable: true },
            { label: "施工许可证编号", code: "sgxkzhm", sortable: true, width: "300" },
            { label: "结构类型", code: "structtype", sortable: true },
            { label: "提交日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "未通过原因", code: "finaltrialidea", sortable: true },
        ],
        body: []
    },
};
export const goodSum_month = {
    table_init: {
        type: "省级优良项目汇总表 - 月考评",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", link: true, sortable: true, width: "200" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "年份", code: "curyear", sortable: true },
            { label: "月份", code: "curmonth", sortable: true },
            { label: "自评分数", code: "evalgrade", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "监督审核时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "提交时间", code: "enddate", sortable: true, dictionary: "date" },
            { label: "是否竣工", code: "isend", sortable: true, dictionary: "isend" },
            { label: "状态", code: "opStatemc", sortable: true },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
        ],
        body: []
    },
};
export const cityDistricts = {
	table_init: {
		type: "设区优良项目汇总表 - 月考评",
		table_code: "t0",
		thead: [
			{ label: "项目名称", code: "proname", link: true, sortable: true, width: "200" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "年份", code: "curyear", sortable: true },
            { label: "月份", code: "curmonth", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "监督审核时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "提交时间", code: "enddate", sortable: true, dictionary: "date" },
            { label: "是否竣工", code: "isend", sortable: true, dictionary: "isend" },
            { label: "项目经理是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "总监是否逾期", code: "isseovertime", sortable: true, dictionary: "isseovertime" },
            { label: "状态", code: "opstatemc", sortable: true },
		],
		body: []
	},
};
export const spotCheckNoticeWatch = {
    table_init: {
        type: "责任停工查看",
        table_code: "t0",
        thead: [
            { label: "责改编码", code: "noticeSerid", link: true, sortable: true, width: "200" },
            { label: "检查时间", code: "checkTime", sortable: true, dictionary: "date" },
            { label: "责改类型", code: "noticeType", sortable: true },
            { label: "处理意见", code: "noticeHandle", sortable: true },
        ],
        body: []
    },
}
export const enterpriseBaseInfor = {
    table_init: {
        type: "施工企业基本信息",
        table_code: "t0",
        thead: [
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "有效期起始日期", code: "certstadate", sortable: true, dictionary: "date" },
            { label: "有效期截止日期", code: "certenddate", sortable: true, dictionary: "date" },
            { label: "资质等级", code: "qualLevel", sortable: true, dictionary: "qualLevel" },
            { label: "企业类别", code: "area", sortable: true },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "考评状态", code: "certstate", sortable: true },
            { label: "是否有效", code: "isenable", sortable: true },
        ],
        body: []
    },
};
export const etpEvalueSelf = {
    table_init: {
        type: "施工企业自评(填报)",
        table_code: "t0",
        thead: [
            { label: "自评分类", code: "evaltype", sortable: true },
            { label: "自评起始日期", code: "evalstadate", sortable: true, dictionary: "date" },
            { label: "自评截止日期", code: "evalenddate", sortable: true, dictionary: "date" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "企业法人代表", code: "unitlegalperson", sortable: true },
            { label: "资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "状态", code: "opstatus", sortable: true, dictionary: "opstatus" },
            { label: "提交时间", code: "opdate", sortable: true, dictionary: "date" },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
        ],
        body: []
    },
};
export const etpEvalueFill = {
    table_init: {
        type: "施工企业考评(填报)",
        table_code: "t0",
        thead: [
            { label: "安全生产许可证号", code: "licensenumber", sortable: true, link: true },
            { label: "有效期起始日期", code: "certstadate", sortable: true, dictionary: "date" },
            { label: "有效期截止日期", code: "certenddate", sortable: true, dictionary: "date" },
            { label: "资质等级", code: "qualLevel", sortable: true, dictionary: "qualLevel" },
            { label: "企业类别", code: "area", sortable: true },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "状态", code: "certstate", sortable: true },
            { label: "审核意见", code: "spidea", sortable: true },
            { label: "是否有效", code: "isenable", sortable: true },
        ],
        body: []
    },
};
export const resultPbulicNotice = {
    table_init: {
        type: "施工企业考评结果公示书",
        table_code: "t0",
        thead: [
            { label: "公示书编号", code: "publicitybh", link: true, sortable: true },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "企业资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "所在地", code: "totalname", sortable: true },
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "考评结果", code: "finalresult", sortable: true },
            { label: "公示起始时间", code: "publicitystadate", sortable: true, dictionary: "date" },
            { label: "公示截止时间", code: "publicitydate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
export const resultNotice = {
    table_init: {
        type: "施工企业考评结果告知书",
        table_code: "t0",
        thead: [
            { label: "公告书编号", code: "informbh", link: true, sortable: true },
            { label: "施工单位", code: "conunitmc", sortable: true },
            { label: "企业资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "所在地", code: "totalname", sortable: true },
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "考评结果", code: "finalresult", sortable: true },
            { label: "公示起始时间", code: "informstadate", sortable: true, dictionary: "date" },
            { label: "公示截止时间", code: "informenddate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
export const dissentReview = {
    table_init: {
        type: "企业考评异议复核(搜索)",
        table_code: "t0",
        thead: [
            { label: "施工企业名称", code: "conunitmc", link: true, sortable: true },
            { label: "考评结果", code: "evalresult", sortable: true },
            { label: "异议结果", code: "finaltrialresult", sortable: true },
            { label: "申请人", code: "sqmanmc", sortable: true },
            { label: "联系电话", code: "sqmantel", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "登记时间", code: "opdate", sortable: true, dictionary: "date" },
            { label: "审核通过实时间", code: "finaltrialdate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
export const etpEvalueQuery = {
    table_init: {
        type: "施工企业考评(搜索)",
        table_code: "t0",
        thead: [
            { label: "施工企业名称", code: "unitname", link: true, sortable: true },
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "有效期起始日期", code: "certstadate", sortable: true, dictionary: "date" },
            { label: "有效期截止日期", code: "certenddate", sortable: true, dictionary: "date" },
            { label: "资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "企业类别", code: "area", sortable: true },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "状态", code: "certstate", sortable: true },
            { label: "提交日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "审核日期", code: "finaltrialdate", sortable: true, dictionary: "date" },
            { label: "考评结果", code: "finalresult", sortable: true },
        ],
        body: []
    },
};
export const revokeResult = {
    table_init: {
        type: "撤销企业考评结果(搜索)",
        table_code: "t0",
        thead: [
            { label: "施工企业名称", code: "conunitmc", link: true, sortable: true },
            { label: "审核日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "公示起始日期", code: "publicitystadate", sortable: true, dictionary: "date" },
            { label: "公示截止日期", code: "publicitydate", sortable: true, dictionary: "date" },
            { label: "公示书编号", code: "publicitybh", sortable: true },
            { label: "决定书编号", code: "informbh", sortable: true },
        ],
        body: []
    },
};
export const revokePublic = {
    table_init: {
        type: "撤销企业考评结果公示书",
        table_code: "t0",
        thead: [
            { label: "施工企业名称", code: "conunitmc", link: true, sortable: true },
            { label: "公示书编号", code: "publicitybh", sortable: true },
            { label: "公示起始日期", code: "publicitystadate", sortable: true, dictionary: "date" },
            { label: "公示截止日期", code: "publicitydate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstate", sortable: true, dictionary: "opstate" },
        ],
        body: []
    },
};
export const revokeDecision = {
    table_init: {
        type: "撤销企业考评结果决定书",
        table_code: "t0",
        thead: [
            { label: "施工企业名称", code: "conunitmc", link: true, sortable: true },
            { label: "告知书编号", code: "informbh", sortable: true },
            { label: "提交日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "审核日期", code: "finaltrialdate", sortable: true, dictionary: "date" },
            { label: "公示期限", code: "publicitydate", sortable: true, dictionary: "date" },
            // { label: "操作", code: "operation", sortable: false },/////////////////操作按钮！！
        ],
        body: []
    },
};
export const reapplyRegister = {
    table_init: {
        type: "重新申请安全生产标准化考核(登记)",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "conunitmc", sortable: true },
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "安全生产许可证有效期", code: "certenddate", sortable: true, dictionary: "date" },
            { label: "企业类别", code: "area", sortable: true },
            { label: "资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "申请类型", code: "sqtype", sortable: true },
            { label: "申请时间", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatemc", sortable: true },
        ],
        body: []
    },
};
export const reapplyQuery = {
    table_init: {
        type: "重新申请安全生产标准化考核(搜索)",
        table_code: "t0",
        thead: [
            { label: "企业名称", code: "conunitmc", link: true, sortable: true },
            { label: "安全生产许可证号", code: "licensenumber", sortable: true },
            { label: "安全生产许可证有效期", code: "licensenumerenddate", sortable: true, dictionary: "date" }, //xxxx至xxx
            { label: "企业类别", code: "conunitarea", sortable: true },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "资质等级", code: "quallevel", sortable: true, dictionary: "qualLevel" },
            { label: "申请类型", code: "sqtype", sortable: true },
            { label: "申请时间", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatemc", sortable: true },
        ],
        body: []
    },
};
//施工企业考评-相关信息材料-企业开展安全生产标准化自评情况-查看详情
export const standarEval = {
    table_init: {
        type: "施工企业自评表",
        table_code: "t0",
        thead: [
            { label: "自评分类", code: "evaltype", sortable: true },
            { label: "自评起始日期", code: "evalstadate", sortable: true, dictionary: "date" },
            { label: "自评截止日期", code: "evalenddate", sortable: true, dictionary: "date" },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "企业法人代表", code: "unitlegalperson", sortable: true },
            { label: "资质等级", code: "quallevalmc", sortable: true },
            { label: "评价时间", code: "opdate", sortable: true, dictionary: "date" },
            { label: "状态", code: "opstatus", sortable: true, dictionary: "opstatus" },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "自评分数", code: "evalgaint", sortable: true },
            { label: "自评结果", code: "evalresult", sortable: true },
        ],
        body: []
    },
};
//施工企业考评-相关信息材料-企业近三年承建已竣工项目安全生产标准化不合格率-查看详情
export const unqualifieds = {
    table_init: {
        type: "企业近三年承建已竣工项目安全生产标准化不合格率",
        table_code: "t0",
        thead: [
            { label: "项目名称", code: "proname", sortable: true, link: true },
            { label: "所在地市", code: "totalname", sortable: true },
            { label: "施工企业名称", code: "conunitmc", sortable: true },
            { label: "监督审核通过时间", code: "aqconfirmdate", sortable: true, dictionary: "date" },
            { label: "自评结果", code: "evalresult", sortable: true },
            { label: "考评结果", code: "finalResult", sortable: true },
            { label: "状态", code: "opstatemc", sortable: true },
            { label: "是否逾期", code: "isover", sortable: true, dictionary: "isover" },
            { label: "项目经理", code: "sgdwxmfzrmc", sortable: true },
            { label: "项目经理提交日期", code: "opdate", sortable: true, dictionary: "date" },
            { label: "监理单位", code: "jldwmc", sortable: true },
            { label: "总监盖章日期", code: "jldwsigndate", sortable: true, dictionary: "date" },
            { label: "建设单位", code: "jsdwmc", sortable: true },
            { label: "建设单位项目负责人盖章日期", code: "jsdwsigndate", sortable: true, dictionary: "date" },
            { label: "施工单位盖章日期", code: "sgdwsigndate", sortable: true, dictionary: "date" },
            { label: "提交审核日期", code: "submitdate", sortable: true, dictionary: "date" },
            { label: "审核日期", code: "finaltrialdate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
//施工企业考评-相关信息材料-企业近三年发生生产安全责任事故情况-查看详情
export const accidents = {
    table_init: {
        type: "企业近三年发生生产安全责任事故情况",
        table_code: "t0",
        thead: [
            { label: "评价标题", code: "situation", sortable: true },
            { label: "不良行为描述", code: "content", sortable: true },
            { label: "不良行为发生日期", code: "happenDate", sortable: true, dictionary: "date" },
            { label: "事故原因", code: "accidentReason", sortable: true },
            { label: "事故类型", code: "accidentType", sortable: true },
            { label: "处罚部门", code: "departName", sortable: true },
            { label: "处罚决定文号", code: "fileNum", sortable: true },
            { label: "处罚日期", code: "punishDate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
//施工企业考评-相关信息材料-企业近三年施工安全监管记分情况-查看详情
export const getActScoreNotices = {
    table_init: {
        type: "企业近三年施工安全监管记分情况",
        table_code: "t0",
        thead: [
            { label: "编号", code: "scorenoticeSuid", link: true, sortable: true },
            { label: "工程项目名称", code: "proName", sortable: true },
            { label: "记分主体", code: "name", sortable: true },
            { label: "所记分值", code: "score", sortable: true },
            { label: "安全分值", code: "safetyScore", sortable: true },
            { label: "签发时间", code: "activeDate", sortable: true, dictionary: "date" },
            { label: "生效日期", code: "onlineDatetime", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
//首页-责令改正通知单
export const correctNotice = {
    table_init: {
        type: "责令改正通知单",
        table_code: "t0",
        thead: [
            { label: "编号", code: "noticeId", link: true, sortable: true },
            { label: "项目名称", code: "proName", sortable: true },
            { label: "改正类别", code: "noticeType", sortable: true },
            { label: "责任主体", code: "unitName", sortable: true },
            { label: "发出时间", code: "activeDate", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
//首页-记分告知单、合同履约评价单
export const showList = {
    table_init: {
        type: "记分告知单、合同履约评价单",
        table_code: "t0",
        thead: [
            { label: "编号", code: "scorenoticeSuid", link: true, sortable: true },
            { label: "工程项目名称", code: "proName", sortable: true },
            { label: "记分主体", code: "name", sortable: true },
            { label: "所记分值", code: "score", sortable: true },
            { label: "签发时间", code: "activeDate", sortable: true, dictionary: "date" },
            { label: "生效日期", code: "onlineDatetime", sortable: true, dictionary: "date" },
        ],
        body: []
    },
};
//首页-监督部门两个工作事项清单
export const projectList = {
    table_init: {
        type: "监督部门两个工作事项清单",
        table_code: "t0",
        thead: [
            { label: "工程项目名称", code: "proName", link: true, sortable: true },
            { label: "申报类别", code: "proType", sortable: true, dictionary: "" },
            { label: "施工单位", code: "sgPm", sortable: true },
            { label: "监理单位", code: "jlSe", sortable: true },
            { label: "事项清单类别", code: "listType", sortable: true },
            { label: "季度", code: "quarter", sortable: true },
            { label: "清单审核通过时间", code: "wfEndTime", sortable: true, dictionary: "date" },
            { label: "文件依据", code: "filetitle", sortable: true },
        ],
        body: []
    },
};



// WEBPACK FOOTER //
// ./src/assets/json.js